import { render, staticRenderFns } from "./Convenios.vue?vue&type=template&id=50a4f26d"
import script from "./Convenios.vue?vue&type=script&lang=js"
export * from "./Convenios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports